import axios from 'axios';
import {
  APP_SETTING_LOADER_SCREEN_SETTINGS_BEGIN,
  APP_SETTING_LOADER_SCREEN_SETTINGS_SUCCESS,
  APP_SETTING_LOADER_SCREEN_SETTINGS_FAILURE,
  APP_SETTING_LOADER_SCREEN_SETTINGS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function loaderScreenSettings(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOADER_SCREEN_SETTINGS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/loader-screen`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOADER_SCREEN_SETTINGS_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOADER_SCREEN_SETTINGS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoaderScreenSettingsError() {
  return {
    type: APP_SETTING_LOADER_SCREEN_SETTINGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOADER_SCREEN_SETTINGS_BEGIN:
      return {
        ...state,
        loaderScreenSettingsPending: true,
        loaderScreenSettingsError: null,
      };

    case APP_SETTING_LOADER_SCREEN_SETTINGS_SUCCESS:
      return {
        ...state,
        loaderScreenSettingsPending: false,
        loaderScreenSettingsError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_LOADER_SCREEN_SETTINGS_FAILURE:
      return {
        ...state,
        loaderScreenSettingsPending: false,
        loaderScreenSettingsError: action.data.error,
      };

    case APP_SETTING_LOADER_SCREEN_SETTINGS_DISMISS_ERROR:
      return {
        ...state,
        loaderScreenSettingsError: null,
      };

    default:
      return state;
  }
}
